
export default {
  month: 'month | months'
}
